import {useEffect, useState} from "react";

import polarisApi from "api/polarisApi";

// One request per page load: the answer only changes when the allow-list on
// the Polaris service changes. `null` while loading.
let cached: Promise<boolean> | null = null;

function fetchAccess(): Promise<boolean> {
	if (!cached) {
		cached = polarisApi
			.getAccess()
			.then((res) => {
				if (res?.status === 200) return Boolean(res.data?.enabled);
				// A refusal is an answer too: asking again only sets off another token refresh
				if (res?.status !== 401 && res?.status !== 403) cached = null;

				return false;
			})
			.catch(() => {
				// a failed check should not stick for the whole session
				cached = null;

				return false;
			});
	}

	return cached;
}

export function usePolarisAccess(): boolean | null {
	const [enabled, setEnabled] = useState<boolean | null>(null);

	useEffect(() => {
		let alive = true;
		fetchAccess().then((value) => {
			if (alive) setEnabled(value);
		});

		return () => {
			alive = false;
		};
	}, []);

	return enabled;
}
